var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.25C0 12.2002 12.2002 0 27.25 0C42.2998 0 54.5 12.2002 54.5 27.25C54.5 42.2998 42.2998 54.5 27.25 54.5C12.2002 54.5 0 42.2998 0 27.25Z",
    fill: "#4CD964"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0938 20.212L35.7912 19.177C35.1492 18.6675 34.776 18.6734 34.2263 19.3438L24.7592 30.8788L20.3535 27.2648C19.7457 26.7606 19.3655 26.7875 18.8658 27.4042L17.8603 28.6966C17.3503 29.3305 17.4155 29.6904 18.0184 30.1875L24.2975 35.3155C24.9439 35.8518 25.3079 35.7966 25.8076 35.1964L37.2573 21.7565C37.795 21.1184 37.7624 20.7371 37.0938 20.212Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f470b564929dca86e84bc5fb9bb2b930.svg";
export { ForwardRef as ReactComponent };